import { Modal, ModalFuncProps } from "antd";

function show(props: ModalFuncProps) {
  Modal.confirm({
    ...props,
    cancelText: props.cancelText ?? "Хаах",
    icon: undefined,
    title: <div className="mb-4">{props.title}</div>,
    autoFocusButton: null,
    okType: props.okType ?? "primary",
    onCancel: props.onCancel ?? Modal.destroyAll,
    onOk: (e) => {
      if (props.onOk) {
        props.onOk(e);
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
  });
}

function showOnly(props: ModalFuncProps) {
  Modal.destroyAll();

  setTimeout(() => {
    show(props);
  });
}

function hide() {
  Modal.destroyAll();
}

export const IOModal = {
  show,
  showOnly,
  hide,
};
